import styled from 'styled-components';
import { withModifiers } from 'utils/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 35px;
  margin: 0 10px;
`;

export const Line = styled.hr`
  border: 1px solid ${({ color }) => color};
  display: flex;
  flex: 1;
  ${withModifiers('dashed')`
    flex: 0.5;
  `}
`;
